import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {QuestionResult} from '../../../data/models/result/question-result';

@Injectable({
  providedIn: 'root'
})
export class QuestionResultService {

  constructor(
    private http: HttpClient,
  ) {
  }

  getQuestionResults(testResultId: number): Promise<QuestionResult[]> {
    return this.http.get<QuestionResult[]>(`api/test-results/${testResultId}/questions`)
      .toPromise();
  }

  updateQuestionResult(testResultId: number, questionId: number, newData: {
    isCorrect?: boolean,
    comment?: string,
  }): Promise<QuestionResult> {

    const formData = new FormData();
    if (newData.isCorrect !== undefined) {
      formData.append('isCorrect', newData.isCorrect.toString());
    }
    if (newData.comment !== undefined) {
      formData.append('comment', newData.comment);
    }

    return this.http.put<QuestionResult>(`api/test-results/${testResultId}/questions/${questionId}`, formData)
      .toPromise();
  }
}
